import { render } from "./ow-appointment-status.vue?vue&type=template&id=a84f7ee6"
import script from "./ow-appointment-status.vue?vue&type=script&lang=js"
export * from "./ow-appointment-status.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__